<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="800px" scrollable>
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="ml-4 text-subtitle">
            <v-icon color="primary" class="mr-2">mdi-lock-outline</v-icon>
            Configurações de segurança
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              :disabled="isFetching"
              icon
              @click="handleClose()"
              class="mr-2"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="height: 350px">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card flat width="100%" height="45px" color="background">
                <v-row no-gutters>
                  <v-card height="45px" flat color="background" width="60px">
                  </v-card>
                  <v-col class="d-flex align-center">
                    <span class="caption mt-1" style="height: 24px">
                      <b> Grupo </b>
                    </span>
                  </v-col>
                  <v-card
                    class="d-flex align-center"
                    height="45px"
                    flat
                    color="background"
                    width="125px"
                  >
                    <span class="caption mt-1" style="height: 24px">
                      <b>Plataforma</b>
                    </span>
                  </v-card>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" style="border: 1px solid #ebeef5">
              <v-card
                v-for="(group, i) in drmGroups"
                class="d-flex flex-row align-center"
                :key="i"
                flat
                height="45"
                width="100%"
                :style="
                  drmGroups.length > i + 1
                    ? 'border-bottom: 1px solid #ebeef5'
                    : ''
                "
              >
                <v-row no-gutters>
                  <v-card
                    class="d-flex align-center justify-center"
                    height="45px"
                    flat
                    color="background"
                    width="60px"
                    :style="
                      i === 0
                        ? 'border-top: 1px solid #ebeef5 !important; border-radius: 0px !important'
                        : ''
                    "
                  >
                    <v-btn icon @click="handleActiveGroup(group)">
                      <v-icon>
                        {{
                          group.isActive
                            ? 'mdi-radiobox-marked'
                            : 'mdi-radiobox-blank'
                        }}
                      </v-icon>
                    </v-btn>
                  </v-card>
                  <v-col class="d-flex align-center justify-start">
                    <span
                      :title="group.name"
                      class="text-truncate"
                      style="max-width: 470px"
                    >
                      <div
                        v-if="group.active"
                        class="mr-1 pa-1 green rounded-circle d-inline-block"
                      />
                      <div
                        v-else
                        class="mr-1 pa-1 error rounded-circle d-inline-block"
                      />
                      {{ group.name }}</span
                    >
                  </v-col>
                  <v-card
                    class="d-flex align-center"
                    height="45px"
                    flat
                    color="background"
                    width="125px"
                    :style="
                      i === 0
                        ? 'border-top: 1px solid #ebeef5 !important; border-radius: 0px !important'
                        : ''
                    "
                  >
                    <span class="caption pl-1" style="height: 24px">
                      {{
                        group.webhook_source_name
                          ? group.webhook_source_name.charAt(0).toUpperCase() +
                            group.webhook_source_name.slice(1)
                          : 'API'
                      }}
                    </span>
                  </v-card>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-8 py-4">
          <v-spacer></v-spacer>
          <v-btn class="px-6" text @click="handleClose" :disabled="isFetching">
            {{ $t('message.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="isFetching"
            :disabled="isFetching"
            @click="handleConfirm"
          >
            <span class="px-5">{{ $t('message.confirm') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'

export default {
  name: 'DrmModalDashboard',
  components: {},
  data: () => ({
    open: null,
    isFetching: false,
    drmGroups: [],
    startValueDrmGroups: [],
    selectedGroups: [],
    selectedItem: null,
  }),
  watch: {
    open(val) {
      if (val === false) this.$root.$emit('DrmModalHasClosed')
    },
  },
  mounted() {
    this.$root.$on('finishUpdateFolderVideosPage', () => {
      this.isFetching = false
      this.handleClose()
    })
    this.$root.$on('drmModalDashboard', (data) => {
      Object.assign(this.$data, this.initialState())
      this.setInfo(data.groups, data.item)
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('finishUpdateFolderVideosPage')
    this.$root.$off('drmModalDashboard')
  },
  methods: {
    checkIfSelected(group) {
      let foundItem = this.selectedGroups.find((searchedItem) => {
        return searchedItem.id === group.id
      })
      if (foundItem) return true
      return false
    },
    handleActiveGroup(activateGroup) {
      this.drmGroups = this.drmGroups.map((group) => {
        if (group.id === activateGroup.id) {
          group.isActive = !group.isActive
        } else if (group.isActive) {
          group.isActive = false
        }
        return group
      })
    },
    setInfo(groups, item) {
      this.selectedItem = item
      if (this.selectedItem.drm_group_ids) {
        let fixedGroups = groups.map((group) => {
          let foundGroup = this.selectedItem.drm_group_ids.find(
            (el) => el.drm_group_id === group.id
          )
          return { ...group, isActive: !!foundGroup }
        })
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      } else {
        let fixedGroups = groups.map((group) => ({ ...group, isActive: false }))
        this.startValueDrmGroups = JSON.parse(JSON.stringify(fixedGroups))
        this.drmGroups = JSON.parse(JSON.stringify(fixedGroups))
      }
    },
    async handleConfirm() {
      this.isFetching = true
      this.getNewGroups()
    },
    getNewGroups() {
      let startActiveArray = this.startValueDrmGroups.map(
        (group) => group.isActive
      )
      let newActiveArray = this.drmGroups.map((group) => group.isActive)
      let arrayIndexes = []
      for (let i = 0; i < startActiveArray.length; i++) {
        if (startActiveArray[i] !== newActiveArray[i]) {
          let indexedValue = i
          arrayIndexes.push(indexedValue)
        }
      }
      this.getGroupChanges(arrayIndexes)
    },
    async getGroupChanges(indexes) {
      let toBeAddedGroups = []
      let toBeRemovedGroups = []
      for (let index of indexes) {
        let changedGroup = this.drmGroups[index]
        if (this.selectedItem.drm_group_ids) {
          let findGroup = this.selectedItem.drm_group_ids.find(
            (group) => group.drm_group_id === changedGroup.id
          )
          if (findGroup) {
            toBeRemovedGroups.push(changedGroup)
          } else {
            toBeAddedGroups.push(changedGroup)
          }
        } else {
          toBeAddedGroups.push(changedGroup)
        }
      }
      for (let group of toBeRemovedGroups) {
        await this.removeItemFromGroup(group)
      }
      for (let group of toBeAddedGroups) {
        await this.addItemFromGroup(group)
      }
      this.updateInPage()
      if (!this.selectedItem.name) {
        this.isFetching = false
        this.handleClose()
      }
    },
    async addItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'increment',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'increment',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        let newObj = {
          active: group.active,
          drm_group_id: group.id,
        }
        if (this.selectedItem.drm_group_ids) {
          this.selectedItem.drm_group_ids.push(newObj)
        } else {
          this.selectedItem.drm_group_ids = [newObj]
        }
      } catch (e) {
        console.log('e', e)
      }
    },
    async removeItemFromGroup(group) {
      let modifiedData = null
      if (this.selectedItem.name) {
        modifiedData = {
          folders: {
            action: 'delete',
            folder_ids: [this.selectedItem.id],
          },
        }
      } else {
        modifiedData = {
          videos: {
            action: 'delete',
            video_ids: [this.selectedItem.id],
          },
        }
      }
      try {
        await drmApi.drmUpdateVideos(group.id, modifiedData)
        this.selectedItem.drm_group_ids =
          this.selectedItem.drm_group_ids.filter(
            (item) => item.drm_group_id != group.id
          )
        if (!this.selectedItem.drm_group_ids.length)
          delete this.selectedItem['drm_group_ids']
      } catch (e) {
        console.log('e', e)
      }
    },
    updateInPage() {
      if (this.selectedItem.name) {
        this.$root.$emit('updateFolderVideosPage', this.selectedItem)
      } else {
        this.$root.$emit('updateVideoVideosPage', this.selectedItem)
      }
    },
    handleClose() {
      this.open = null
      this.$root.$emit('resetIsAnyOtherModal')
    },
    initialState() {
      return {
        open: null,
        isFetching: false,
        drmGroups: [],
        startValueDrmGroups: [],
        selectedItem: null,
      }
    },
  },
}
</script>

<style></style>
